"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializableIgnoreProps = exports.serializable = exports.toJSON = void 0;
var tslib_1 = require("tslib");
var merge_1 = require("./merge");
/*
 * A class decorator that adds a way to add ignored fields to the toJson in serialization.
 */
var toJSON = function (target, ignoreAdditionalKeys) {
    if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
    if (!Array.isArray(ignoreAdditionalKeys)) {
        ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
    }
    var regexIgnorePrivate = /^_.+/;
    var simpleObject = tslib_1.__rest(target, []);
    var ignoreKeys = Object.keys(simpleObject)
        .filter(function (key) { return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function'; })
        .concat(ignoreAdditionalKeys, 'logger', 'arrToIgnoreKeys');
    return (0, merge_1.withoutKeys)(ignoreKeys).merge({}, simpleObject);
};
exports.toJSON = toJSON;
exports.serializable = { ignore: function () { } }; // eslint-disable-line @typescript-eslint/no-empty-function
exports.serializable = function (target) {
    target.prototype.toJSON = function (ignoreAdditionalKeys) {
        if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
        if (!Array.isArray(this.arrToIgnoreKeys)) {
            this.arrToIgnoreKeys = [];
        }
        return (0, exports.toJSON)(this, this.arrToIgnoreKeys.concat(ignoreAdditionalKeys));
    };
};
exports.serializable.ignore = function (target, propertyKey) { return (0, exports.serializableIgnoreProps)(target, propertyKey); }; // eslint-disable-line @typescript-eslint/no-confusing-void-expression
/*
 * A property decorator to add ignored fields to the toJson in serialization
 */
var serializableIgnoreProps = function (target, propertyKey) {
    if (!target.arrToIgnoreKeys) {
        target.arrToIgnoreKeys = [];
    }
    if (!target.arrToIgnoreKeys.includes(propertyKey)) {
        target.arrToIgnoreKeys.push(propertyKey);
    }
};
exports.serializableIgnoreProps = serializableIgnoreProps;
//# sourceMappingURL=not-serialize.js.map